export default "__VITE_ASSET__B4ZNPS7$__"